import React from 'react';
import { useParams } from 'react-router-dom';

import { Box } from '@clutter/clean';

import { Col } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Panel } from '@admin/components/helpers/panel';
import { OrderMap } from '@admin/components/orders/map';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useTaskOrderContextQuery, useTaskOrderEditQuery } from '@admin/schema';

import { Breadcrumbs } from './components/breadcrumbs';
import { EditPanel } from './components/edit_panel';
import { TasksPanel } from './components/tasks_panel';

export const TaskOrderEdit = () => {
  useTitle('Task Order');
  const { accountID, orderID } = useParams<{ accountID: string; orderID: string }>();
  const { data: { account } = {} } = useTaskOrderContextQuery({ client, variables: { accountID: accountID } });
  const { data: { order } = {}, loading, error } = useTaskOrderEditQuery({ client, variables: { orderID } });

  if (!account || loading) {
    return null;
  }

  if (!order || error) {
    throw new Error('Cannot load task order');
  }

  return (
    <>
      <PageHeader>
        <Breadcrumbs order={order} />
      </PageHeader>
      <Panel>
        <Panel.Header>
          <Panel.Title>Edit Tasks</Panel.Title>
        </Panel.Header>
        <Panel.Body>
          <Box.Flex margin="0 -8px">
            <Col xs={12} lg={6}>
              <TasksPanel accountID={accountID} orderID={order.id} initialTasks={order.tasks ?? []} />
            </Col>
            <Col xs={12} lg={6}>
              <OrderMap orderID={order.id} />
            </Col>
          </Box.Flex>
        </Panel.Body>
      </Panel>
      <EditPanel order={order} />
    </>
  );
};
